/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-01-05 11:29:10
 *
 *******************************************************/
// @flow
import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactTooltip from 'react-tooltip';
import { Icon } from '@shopify/polaris';
// import { CollectionsMajor, ListMajor, SettingsMajor } from '@shopify/polaris-icons';
import { withI18n } from '@shopify/react-i18n';
import Classnames from 'classnames';

import MenuStyles from './menu-styles';
import MenuDeveloper from './menu-developer';

import { getFullAppUrlV2 } from 'src/helpers';
import { routes } from 'src/routes';
import { SIDEBAR_MENU, DEVICE } from 'src/constants/theme-settings';
import { ReactComponent as IconBrush } from 'src/assets/images/shopify-integration-settings/brush.svg';
import * as ShopifyIntegrationSettingsAction from 'src/stores/actions/shopify-integration/shopify-integration-settings-actions';

type Props = {
  isDifferentFormOrigin: boolean,
  upsertElementActions: (type: string, properties: Record<string, any>) => void
};

type ComposedProps = Props & WithI18nProps;

type State = {};

class MenuSettingsVisualEditor extends Component<ComposedProps, State> {
  menuSidebars = [
    {
      icon: IconBrush,
      iconCustom: true,
      tab: SIDEBAR_MENU.STYLE,
      tooltip: this.props.i18n.translate('AdminHTML.ShopifyIntegrationSettings.MenuSettings.style')
    }
    // {
    //   icon: CollectionsMajor,
    //   tab: SIDEBAR_MENU.PRODUCT_ITEM,
    //   tooltip: this.props.i18n.translate(
    //     'AdminHTML.ShopifyIntegrationSettings.MenuSettings.productItem'
    //   )
    // },
    // {
    //   icon: ListMajor,
    //   tab: SIDEBAR_MENU.PRODUCT_LIST,
    //   tooltip: this.props.i18n.translate(
    //     'AdminHTML.ShopifyIntegrationSettings.MenuSettings.productList'
    //   )
    // },
    // {
    //   icon: SettingsMajor,
    //   tab: SIDEBAR_MENU.ADVANCED_SETTINGS,
    //   tooltip: this.props.i18n.translate(
    //     'AdminHTML.ShopifyIntegrationSettings.MenuSettings.advancedSettings'
    //   )
    // }
  ];

  handleChangeSidebar = item => {
    const { updateMultiFieldsReducer } = this.props;
    if (item.tab === SIDEBAR_MENU.CODE_EDITOR) {
      const { templateId } = this.props;
      const codeEditorUrl = getFullAppUrlV2(
        routes.shopifyIntegration.ssrCodeEditor.view(templateId)
      );
      window.open(codeEditorUrl, '_blank');
    } else {
      updateMultiFieldsReducer({
        sideBarMenu: item.tab,
        activeMenuItem: ''
      });
    }
  };

  render() {
    const {
      // i18n,
      sideBarMenu,
      isExpandFullscreen,
      developerMode
      // isDifferentFormOrigin,
      // upsertElementActions
    } = this.props;
    const leftPanelContainerClass = Classnames('visual-editor-left-panel-container', {
      opened: !isExpandFullscreen
    });

    if (developerMode) {
      return <MenuDeveloper />;
    }

    return (
      <div className={leftPanelContainerClass}>
        <div className="visual-editor-sidebar">
          {this.menuSidebars.map((item, index) => (
            <div
              key={index}
              className={Classnames('visual-editor-sidebar__item', {
                active: item.tab === sideBarMenu
              })}
              onClick={() => this.handleChangeSidebar(item)}
              data-for="menu-sidebar"
              data-tip={item.tooltip}>
              {item?.iconCustom ? (
                <span
                  className={`Polaris-Icon Polaris-Icon--custom ${
                    item.tab === sideBarMenu ? 'Polaris-Icon--colorPrimary' : ''
                  }`}>
                  <span className="Polaris-VisuallyHidden"></span>
                  <item.icon className="Polaris-Icon__Svg" />
                </span>
              ) : (
                <Icon source={item.icon} color={item.tab === sideBarMenu ? 'primary' : 'base'} />
              )}
            </div>
          ))}
          <ReactTooltip
            id="menu-sidebar"
            place="right"
            effect="solid"
            type="light"
            overridePosition={({ left, top }, currentEvent, currentTarget, node) => {
              const d = document.documentElement;
              left = Math.min(d.clientWidth - node.clientWidth, left);
              top = Math.min(d.clientHeight - node.clientHeight, top);
              left = Math.max(0, left - 14);
              top = Math.max(0, top - 6);
              return { top, left };
            }}
          />
        </div>

        <MenuStyles />
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  updateFieldReducer: (fieldName, data) =>
    dispatch(ShopifyIntegrationSettingsAction.handleUpdateField(fieldName, data)),
  updateMultiFieldsReducer: data =>
    dispatch(ShopifyIntegrationSettingsAction.handleUpdateMultiFields(data))
});

const mapStateToProps = (state, props) => {
  const isExpandFullscreen = props.prevDevice === DEVICE.FULLSCREEN;

  return {
    isExpandFullscreen,
    sideBarMenu: _.get(state, 'shopifyIntegrationSettings.sideBarMenu', ''),
    developerMode: _.get(state, 'shopifyIntegrationSettings.developerMode', false)
  };
};

export default withI18n()(connect(mapStateToProps, mapDispatchToProps)(MenuSettingsVisualEditor));
